import React from "react";
import LoginContainer from "Shared/Login/Container";
import { RenderPrice } from "Shared/Price/ProductPrice";
import SignUpLink from "Shared/ProductCard/SignUpLink/SignUpLink";
const PriceBlock = ({ selectedVariant, isInCampaign }) => {
    return (React.createElement(LoginContainer, null, ({ isLoggedIn }) => isLoggedIn ? (React.createElement(RenderPrice, { variant: selectedVariant, productIsInCampaign: isInCampaign })) : (React.createElement(SignUpLink, null))));
};
export default PriceBlock;
